
import Vue from 'vue';
import {
  LabelAssignment, SelectionResult,
} from '@/model';
import labels from '@/store/labels';
import { groupBy } from '@/util/array-util';
import DataTable, { Column } from '@/components/tables/DataTable.vue';
import users from '@/store/users';

interface LabelAssignmentFrequency {
  user?: string;
  type: 'added' | 'removed';
  labelId?: number;
  labelCode?: string;
  labelType?: string
  count: number;
}

export default Vue.extend({
  components: { DataTable },
  props: {
    value: { type: Object as () => SelectionResult, required: true },
    assignments: { type: Array as () => LabelAssignment[] | undefined },
  },
  data() {
    return {
      tableHeaders: [
        {
          header: 'User', value: 'user', type: 'string', filterable: true,
        },
        {
          header: 'Type', value: 'type', type: 'string', filterable: true,
        },
        {
          header: 'Label Type', value: 'labelType', type: 'string', filterable: true,
        },
        {
          header: 'Label', value: 'labelCode', type: 'string', filterable: true,
        },
        {
          header: 'Count', value: 'count', type: 'number', sort: 'desc',
        },
      ] as Column[],
    };
  },

  computed: {
    labelAssignmentFrequency(): LabelAssignmentFrequency[] {
      if (!this.assignments) {
        return [];
      }
      const additions = Array.from(groupBy(this.assignments, (a) => `${a.userId}:${a.labelId}`))
        .map(([_, events]) => {
          const user = events[0].userId ? users.getters.lookup.get(events[0].userId)?.displayName : undefined;
          const label = labels.getters.lookup.get(events[0].labelId);
          return {
            user,
            type: 'added' as const,
            labelId: events[0].labelId,
            labelCode: label?.code,
            labelType: label?.type,
            count: events.length,
          };
        });

      const deletions = Array.from(groupBy(this.assignments.filter((d) => d.deleted), (a) => `${a.deletedBy}:${a.labelId}`))
        .map(([_, events]) => ({
          user: events[0].deletedBy ? users.getters.lookup.get(events[0].deletedBy)?.displayName : undefined,
          type: 'removed' as const,
          labelId: events[0].labelId,
          labelCode: labels.getters.lookup.get(events[0].labelId)?.code,
          labelType: labels.getters.lookup.get(events[0].labelId)?.type,
          count: events.length,
        }));

      return [...additions, ...deletions];
    },
  },
});
